<template>
  <path pid="0" d="M13 2a11 11 0 1011 11A11 11 0 0013 2zm6 12h3a9 9 0 01-8 8v-3a1 1 0 00-2 0v3a9 9 0 01-7.95-8H7a1 1 0 000-2H4.05a9 9 0 018-7.95V7a1 1 0 002 0V4.05a9 9 0 018 8H19a1 1 0 000 2z"/>
</template>
